
export default {
  name: "Toggle",
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    value: {
      default: null,
      type: [String, Boolean]
    },
    checked: {
      type: Boolean,
      default: false,
    },
    checkedText:{
      type: String,
      default: 'On'
    },
    uncheckedText:{
      type: String,
      default: 'Off'
    },
    disabled:{
      type: Boolean,
      default: false,
    }
  },
  computed: {
    proxyChecked: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },
};
